//import external libraries
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//import internal services and libraries
//Components
import config from "../../utils/config";
import MapboxAPI from "../components/map/MapboxAPI";
import TableAirQualityLevels from "./TableAirQualityLevels";
import TableDryWetMean from "./TableDryWetMean";
import ChartAQI from "./dashboard/CharAQI";
//Services
import { getUserLocation } from "../../utils/services/userService";
import {
  createProj,
  getAirQualityCurrent,
  getAirQualityYearly,
  getElectricityCostHome,
  getProjectLocationConditions,
} from "../../utils/services/projectService";

//Functions
import {
  calculateWetBulbTemperature,
  calcutationFunctions,
  calculateDewPoint,
  findHumidityRatio,
} from "../../utils/calculationFunctions";

import { handleKeyPressFolderPath } from "../../utils/validationFunctions";
//Actions
import {
  setInitialState,
  setLocationMarkerPosition,
} from "../../actions/locationActions";
import { logOut } from "../../actions/authActions";
import { setSnackbar } from "../../actions/snackbarActions";
import { appCtx } from "../../utils/hooks/appContext";
import { themeCtx } from "../../utils/hooks/themeContext";

//import MUI components
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Backdrop from "@mui/material/Backdrop";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Customer from "./Customer";

function CreateProject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();
  const { setProjectId } = useContext(appCtx);
  const [locationDataLoading, setLocationDataLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  let {
    address: reduxAddress,
    city: reduxCity,
    country: reduxCountry,
    countryShortCode,
    markerPosition: reduxMarkerPosition,
    elevation: reduxElevation,
  } = useSelector((state) => state.location);

  const [project, setProject] = useState({
    jwt: localStorage.getItem(config.jwt_key_name),
    number: "AHU1",
    costDriver: "22R&D0006",
    name: "",
    country: "",
    address: "",
    city: "",
    //station data
    stationId: "",
    stationName: "",
    //summer
    summerOutdoorTemperature: 0,
    summerWetBulbTemperature: 0,
    summerDewPointTemperature: 0,
    summerOutdoorHumidity: 0,
    //winter
    winterOutdoorTemperature: 0,
    winterOutdoorHumidity: 0,
    winterOutdoorHumidityRatio: 0,
    elevation: 0,
    //electricity
    elPriceBusiness: 0,
    elPriceHome: 0,
    status: "",
    //Weather
    aqiCurrent: 0,
    aqiYearlyAverage: 0,
    qualityGood: 0,
    qualityModerate: 0,
    qualitySensitive: 0,
    qualityUnhealthy: 0,
    qualityUnhealthyV: 0,
    qualityHazardous: 0,
    distanceTemperature: 0,
    distance: 0,

    //Dodala sam jer nije radilo kreiranje objekta, potrebno setovati ispravnu vrednost
    totalPrice: 0,
    //customer data
    ERPId: "",
    customerName: "",
    customerRepresentative: "",
    customerPhone: "",
    customerEmail: "",
  });

  //Polja za lokaciju - koordinate kupca
  const [location, setLocation] = useState(config.termoventHQ);
  const [showLocation, setShowLocation] = useState(false);
  const [showCustomerData, setShowCustomerData] = useState(false);
  const [showSummerWinter, setShowSummerWinter] = useState(false);
  const [showAirQuality, setShowAirQuality] = useState(false);
  const [manualAdjustmentsChecked, setManualAdjustments] = useState(false);
  const [airQuality, setAirQuality] = useState(false);
  const [electricity, setElectricity] = useState(false);
  const [initialValues, setInitialValues] = useState({
    jwt: localStorage.getItem(config.jwt_key_name),
    number: "AHU1",
    costDriver: "22R&D0006",
  });

  //validacija
  const [name, setName] = useState(false);
  const [elevation, setElevation] = useState(false);
  const [summerOutdoorTemperature, setSummerOutdoorTemperature] =
    useState(false);
  const [summerWetBulbTemperature, setSummerWetBulbTemperature] =
    useState(false);
  const [summerDewPointTemperature, setSummerDewPointTemperature] =
    useState(false);
  const [summerOutdoorHumidity, setSummerOutdoorHumidity] = useState(false);
  const [winterOutdoorTemperature, setWinterOutdoorTemperature] =
    useState(false);
  const [winterOutdoorHumidity, setWinterOutdoorHumidity] = useState(false);
  const [elPriceBusiness, setElectricityUtilityRates] = useState(false);
  const [elPriceHome, setElPriceHome] = useState(false);
  const [aqiCurrent, setAqiCurrent] = useState(false);
  const [aqiYearlyAverage, setAqiYearlyAverage] = useState(false);
  const [dryBulbTemperatures, setDryBulbTemperatures] = useState([]);
  const [wetBulbTemperatures, setWetBulbTemperatures] = useState([]);
  const [meanDailyTemperatureRange, setMeanDailyTemperatureRange] = useState(
    []
  );
  const { currentTheme } = useContext(themeCtx);

  //Validacija obaveznih polja
  const areMandatoryFieldsFilled = (proj) => {
    if (
      !proj.name ||
      !proj.summerOutdoorTemperature ||
      !proj.summerWetBulbTemperature ||
      !proj.summerDewPointTemperature ||
      !proj.summerOutdoorHumidity ||
      !proj.aqiCurrent ||
      !proj.elPriceBusiness ||
      !proj.winterOutdoorTemperature ||
      !proj.winterOutdoorHumidity ||
      !proj.aqiYearlyAverage ||
      !proj.elPriceHome
    )
      return false;
    return true;
  };

  function validateInput(name, value, minValue, maxValue) {
    let newValue;
    if (value !== "" && value !== "-") {
      if (parseFloat(value) > minValue && parseFloat(value) < maxValue)
        newValue = value;
      else {
        newValue = initialValues[name];
        dispatch(
          setSnackbar(
            true,
            "error",
            t(
              "createproject.validation" + name[0].toUpperCase() + name.slice(1)
            )
          )
        );
      }
    } else newValue = value;
    return newValue;
  }
  const validate = () => {
    let validationFailed = false;

    if (project.name.length > 0 && project.name.length < 51) {
      if (!/[\\/:\*\?"<>\|]+/.test(project.name)) {
        setName(false);
      } else {
        setName(true);
        validationFailed = true;
      }
    } else {
      setName(true);
      validationFailed = true;
    }

    if (
      project.summerOutdoorTemperature !== "" &&
      project.summerOutdoorTemperature != "-"
    ) {
      setSummerOutdoorTemperature(false);
    } else {
      setSummerOutdoorTemperature(true);
      validationFailed = true;
    }
    if (project.elevation !== "" && project.elevation != "-") {
      setElevation(false);
    } else {
      setElevation(true);
      validationFailed = true;
    }

    if (project.summerWetBulbTemperature !== "") {
      setSummerWetBulbTemperature(false);
    } else {
      setSummerWetBulbTemperature(true);
      validationFailed = true;
    }

    if (project.summerDewPointTemperature !== "") {
      setSummerDewPointTemperature(false);
    } else {
      setSummerDewPointTemperature(true);
      validationFailed = true;
    }

    if (project.summerOutdoorHumidity !== "") {
      setSummerOutdoorHumidity(false);
    } else {
      setSummerOutdoorHumidity(true);
      validationFailed = true;
    }

    if (project.elPriceBusiness != "") {
      setElectricityUtilityRates(false);
    } else {
      setElectricityUtilityRates(true);
      validationFailed = true;
    }

    if (project.elPriceHome != "") {
      setElPriceHome(false);
    } else {
      setElPriceHome(true);
      validationFailed = true;
    }

    if (project.aqiCurrent !== "") {
      setAqiCurrent(false);
    } else {
      setAqiCurrent(true);
      validationFailed = true;
    }

    if (project.winterOutdoorTemperature !== "") {
      setWinterOutdoorTemperature(false);
    } else {
      setWinterOutdoorTemperature(true);
      validationFailed = true;
    }

    if (project.winterOutdoorHumidity !== "") {
      setWinterOutdoorHumidity(false);
    } else {
      setWinterOutdoorHumidity(true);
      validationFailed = true;
    }

    if (project.aqiYearlyAverage !== "") {
      setAqiYearlyAverage(false);
    } else {
      setAqiYearlyAverage(true);
      validationFailed = true;
    }
    validationFailed &&
      dispatch(setSnackbar(true, "error", t("snackbar.createProjectError")));
    return validationFailed;
  };
  const handleProjectChange = (e) => {
    let { name, value } = e.target;

    if (
      name === "summerOutdoorTemperature" ||
      name === "winterOutdoorTemperature"
    ) {
      let newValue = validateInput(name, value, -31, 56);

      setProject((prev) => {
        return {
          ...prev,
          [name]: newValue,
        };
      });
    } else if (
      name === "summerOutdoorHumidity" ||
      name === "winterOutdoorHumidity"
    ) {
      let newValue = validateInput(name, value, -1, 101);

      setProject((prev) => {
        return {
          ...prev,
          [name]: newValue,
        };
      });
    } else {
      setProject((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    }
  };

  useEffect(() => {
    //kalkulacija polja za wet bulb i dew point na osnovu dry bulb i vlaznosti

    let wetBulbTemperature = calculateWetBulbTemperature(
      project.summerOutdoorTemperature,
      project.summerOutdoorHumidity
    );
    let dewPointTemperature = calculateDewPoint(
      +project.summerOutdoorTemperature,
      +project.summerOutdoorHumidity
    );

    setProject((prev) => {
      return {
        ...prev,
        summerWetBulbTemperature: wetBulbTemperature,
        summerDewPointTemperature: dewPointTemperature,
      };
    });
  }, [project.summerOutdoorTemperature, project.summerOutdoorHumidity]);

  useEffect(() => {
    let humidityRatio = findHumidityRatio(
      +project.winterOutdoorTemperature,
      +project.winterOutdoorHumidity,
      +project.elevation
    );

    setProject((prev) => {
      return {
        ...prev,
        winterOutdoorHumidityRatio: humidityRatio,
      };
    });
  }, [
    project.winterOutdoorTemperature,
    project.winterOutdoorHumidity,
    project.elevation,
  ]);

  const handleChosenLocation = (
    address,
    city,
    country,
    countryShortCode,
    markerPosition,
    elevation
  ) => {
    // pozvati backend tim odgovorima (napravi model za odgovor)

    setLoading(true);
    setInitialValues((prev) => {
      return {
        ...prev,

        address: reduxAddress.replaceAll("undefined", "").trim(),
        city: reduxCity,
        country: reduxCountry,
        markerPosition: reduxMarkerPosition,
        elevation: reduxElevation,
      };
    });
    setProject((prev) => {
      return {
        ...prev,

        address: reduxAddress.replaceAll("undefined", "").trim(),
        city: reduxCity,
        country: reduxCountry,
        markerPosition: reduxMarkerPosition,
        elevation: reduxElevation,
      };
    });

    getAirQualityCurrent(markerPosition.lat, markerPosition.lng)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          setInitialValues((prev) => {
            return {
              ...prev,
              aqiCurrent: res.data.data,
            };
          });
          setProject((prev) => {
            return {
              ...prev,
              aqiCurrent: res.data.data,
            };
          });
        } else if (res.statusCode === 401) {
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });

    getAirQualityYearly(markerPosition.lat, markerPosition.lng)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          if (res.data.data !== null) {
            setInitialValues((prev) => {
              return {
                ...prev,

                aqiYearlyAverage: res.data.data.yearlyAverage,
                qualityGood: res.data.data.qualityGood,
                qualityModerate: res.data.data.qualityModerate,
                qualitySensitive: res.data.data.qualitySensitive,
                qualityUnhealthy: res.data.data.qualityUnhealthy,
                qualityUnhealthyV: res.data.data.qualityUnhealthyV,
                qualityHazardous: res.data.data.qualityHazardous,
                distance: res.data.data.distance,
              };
            });
            setProject((prev) => {
              return {
                ...prev,

                aqiYearlyAverage: res.data.data.yearlyAverage,
                qualityGood: res.data.data.qualityGood,
                qualityModerate: res.data.data.qualityModerate,
                qualitySensitive: res.data.data.qualitySensitive,
                qualityUnhealthy: res.data.data.qualityUnhealthy,
                qualityUnhealthyV: res.data.data.qualityUnhealthyV,
                qualityHazardous: res.data.data.qualityHazardous,

                distance: res.data.data.distance,
              };
            });
          } else {
            setInitialValues((prev) => {
              return {
                ...prev,

                aqiYearlyAverage: 0,
                qualityGood: 0,
                qualityModerate: 0,
                qualitySensitive: 0,
                qualityUnhealthy: 0,
                qualityUnhealthyV: 0,
                qualityHazardous: 0,
                distance: 0,
              };
            });
            setProject((prev) => {
              return {
                ...prev,

                aqiYearlyAverage: 0,
                qualityGood: 0,
                qualityModerate: 0,
                qualitySensitive: 0,
                qualityUnhealthy: 0,
                qualityUnhealthyV: 0,
                qualityHazardous: 0,

                distance: 0,
              };
            });
          }
        } else if (res.statusCode === 401) {
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
          setTimeout(() => {
            dispatch(logOut());
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    //getAqiAverage;
    getElectricityCostHome(countryShortCode)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          setInitialValues((prev) => {
            return {
              ...prev,
              elPriceBusiness: res.data.data.electricityCost,
              elPriceHome: res.data.data.electricityCostHome,
            };
          });
          setProject((prev) => {
            return {
              ...prev,
              elPriceBusiness: res.data.data.electricityCost,
              elPriceHome: res.data.data.electricityCostHome,
            };
          });
        } else if (res.statusCode === 401)
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
      })
      .catch((err) => {
        console.log(err);
      });
    getProjectLocationConditions(markerPosition.lat, markerPosition.lng)
      .then((res) => {
        if (res.statusCode >= 200 && res.statusCode < 300) {
          setInitialValues((prev) => {
            return {
              ...prev,
              stationId:
                res.data.data.basicDesignConditions.stationId,
              stationName:
                res.data.data.basicDesignConditions.stationName,               
              summerOutdoorTemperature:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerOutdoorTemperature,
              summerWetBulbTemperature:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerWetBulbTemperature,
              summerDewPointTemperature:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerDewPointTemperature,
              summerOutdoorHumidity:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerOutdoorHumidity,
              winterOutdoorTemperature:
                res.data.data.basicDesignConditions.winterDesignConditions
                  .winterOutdoorTemperature,
              winterOutdoorHumidity:
                res.data.data.basicDesignConditions.winterDesignConditions
                  .winterOutdoorHumidity,
              winterOutdoorHumidityRatio:
                res.data.data.basicDesignConditions.winterDesignConditions
                  .winterOutdoorHumidityRatio,
              //elevation:
              //res.data.data.basicDesignConditions.winterDesignConditions
              //.elevation,
            };
          });
          setProject((prev) => {
            return {
              ...prev,

              stationId:
                res.data.data.basicDesignConditions.stationId,
              stationName:
                res.data.data.basicDesignConditions.stationName,
              summerOutdoorTemperature:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerOutdoorTemperature,
              summerWetBulbTemperature:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerWetBulbTemperature,
              summerDewPointTemperature:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerDewPointTemperature,
              summerOutdoorHumidity:
                res.data.data.basicDesignConditions.summerDesignConditions
                  .summerOutdoorHumidity,
              winterOutdoorTemperature:
                res.data.data.basicDesignConditions.winterDesignConditions
                  .winterOutdoorTemperature,
              winterOutdoorHumidity:
                res.data.data.basicDesignConditions.winterDesignConditions
                  .winterOutdoorHumidity,
              distanceTemperature: res.data.data.basicDesignConditions.distance,
              //distance: res.data.data.distance, //.toFixed(3)
              winterOutdoorHumidityRatio:
                res.data.data.basicDesignConditions.winterDesignConditions
                  .winterOutdoorHumidityRatio,
              //elevation:
              //res.data.data.basicDesignConditions.winterDesignConditions
              //.elevation,
            };
          });

          setDryBulbTemperatures(
            res.data.data.monthlyDesign.dryBulbTemperatures
          );
          setWetBulbTemperatures(
            res.data.data.monthlyDesign.wetBulbTemperatures
          );
          setMeanDailyTemperatureRange(
            res.data.data.monthlyDesign.meanDailyTemperatureRange
          );
        } else if (res.statusCode === 401)
          dispatch(
            setSnackbar(true, "error", t("snackbar.tokenExpired"), "/")
          );
      })
      .catch((err) => {
        console.log(err);
      });

    setLoading(false);
  };

  const handleChangeSummerWinter = (event) => {
    setManualAdjustments(event.target.checked);
  };

  const handleChangeAirQuality = (event) => {
    setAirQuality(event.target.checked);
  };

  const handleChangeElectricity = (event) => {
    setElectricity(event.target.checked);
  };

  const handleFocus = (event) => {
    event.target.select();
  };

  //Slanje HTTP zahteva za cuvanje projekta u bazi
  const createProject = (e) => {
    const checkValidity = validate();

    if (checkValidity) return;

    setLoading(true);

    let projectForSave;

    if (manualAdjustmentsChecked && airQuality && electricity) {
      projectForSave = project;
    } else if (!manualAdjustmentsChecked && !airQuality && !electricity) {
      projectForSave = {
        ...initialValues,
        name: project.name,
      };
    } else if (!manualAdjustmentsChecked && !airQuality && electricity) {
      projectForSave = {
        ...initialValues,
        name: project.name,
        elPriceBusiness: project.elPriceBusiness,
        elPriceHome: project.elPriceHome,
      };
    } else if (!manualAdjustmentsChecked && airQuality && !electricity) {
      projectForSave = {
        ...initialValues,
        name: project.name,
        aqiCurrent: project.aqiCurrent,
        aqiYearlyAverage: project.aqiYearlyAverage,
        qualityGood: project.qualityGood,
        qualityModerate: project.qualityModerate,
        qualitySensitive: project.qualitySensitive,
        qualityUnhealthy: project.qualityUnhealthy,
        qualityUnhealthyV: project.qualityUnhealthyV,
        qualityHazardous: project.qualityHazardous,
      };
    } else if (manualAdjustmentsChecked && airQuality && !electricity) {
      projectForSave = {
        ...project,

        elPriceBusiness: initialValues.elPriceBusiness,
        elPriceHome: initialValues.elPriceHome,
      };
    } else if (manualAdjustmentsChecked && !airQuality && electricity) {
      projectForSave = {
        ...project,

        aqiCurrent: initialValues.aqiCurrent,
        aqiYearlyAverage: initialValues.aqiYearlyAverage,
        qualityGood: initialValues.qualityGood,
        qualityModerate: initialValues.qualityModerate,
        qualitySensitive: initialValues.qualitySensitive,
        qualityUnhealthy: initialValues.qualityUnhealthy,
        qualityUnhealthyV: initialValues.qualityUnhealthyV,
        qualityHazardous: initialValues.qualityHazardous,
      };
    } else if (!manualAdjustmentsChecked && airQuality && electricity) {
      projectForSave = {
        ...initialValues,
        name: project.name,
        elPriceBusiness: project.elPriceBusiness,
        elPriceHome: project.elPriceHome,
        aqiCurrent: project.aqiCurrent,
        aqiYearlyAverage: project.aqiYearlyAverage,
        qualityGood: project.qualityGood,
        qualityModerate: project.qualityModerate,
        qualitySensitive: project.qualitySensitive,
        qualityUnhealthy: project.qualityUnhealthy,
        qualityUnhealthyV: project.qualityUnhealthyV,
        qualityHazardous: project.qualityHazardous,
      };
    } else {
      projectForSave = {
        ...project,
        aqiCurrent: initialValues.aqiCurrent,
        aqiYearlyAverage: initialValues.aqiYearlyAverage,
        qualityGood: initialValues.qualityGood,
        qualityModerate: initialValues.qualityModerate,
        qualitySensitive: initialValues.qualitySensitive,
        qualityUnhealthy: initialValues.qualityUnhealthy,
        qualityUnhealthyV: initialValues.qualityUnhealthyV,
        qualityHazardous: initialValues.qualityHazardous,

        elPriceBusiness: initialValues.elPriceBusiness,
        elPriceHome: initialValues.elPriceHome,
      };
    }

    const requestData = {
      ...projectForSave,
      localDateTime: new Date(),
      timeZone: new Date().getTimezoneOffset(),
      ERPId: project.ERPId,
      customerName: project.customerName,
      customerRepresentative: project.customerRepresentative,
      customerPhone: project.customerPhone,
      customerEmail: project.customerEmail,
      elevation: project.elevation,
    };

    createProj(requestData)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          setProjectId(response.data.id);

          dispatch(
            setSnackbar(
              true,
              "success",
              t("snackbar.createProjectSuccess"),
              "/project-item",
              {
                replace: true,
              }
            )
          );

          setLoading(false);
        } else {
          dispatch(
            setSnackbar(true, "error", t("snackbar.createProjectError"))
            //setSnackbar(true, "error", response.message)
          );

          /*response.data.map((errorItem) => {
            console.log(errorItem);
            switch (errorItem.property) {
              case "AqiCurrent":
                setAqiCurrent(true);
                break;
              case "AqiYearlyAverage":
                setAqiYearlyAverage(true);
                break;
            }
          });*/
          //setAqiCurrent(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, "error", t("snackbar.createProjectError")));
        setLoading(false);
      });
  };

  return (
    <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
      <Paper
        variant="outlined"
        elevation={0}
        sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
      >
        <Box sx={{ mt: 1 }}>
          <TextField
            color="secondary"
            id="name"
            label={t("createproject.projectname")}
            name="name"
            type="text"
            value={project.name}
            onChange={(e) => {
              setName(false);
              handleProjectChange(e);
            }}
            onFocus={() => setName(false)}
            onKeyPress={handleKeyPressFolderPath}
            error={name}
            helperText={name ? `${t("createproject.validationName")}` : ""}
            inputProps={{ maxLength: 80 }}
          />
          {currentTheme && (
            <Customer
              showCustomerData={showCustomerData}
              setShowCustomerData={setShowCustomerData}
              handleChange={handleProjectChange}
              ERPId={project.ERPId}
              customerName={project.customerName}
              customerRepresentative={project.customerRepresentative}
              customerPhone={project.customerPhone}
              customerEmail={project.customerEmail}
            ></Customer>
          )}
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
          >
            <header>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "24px" },
                  marginRight: "10px",
                }}
              >
                {t("createproject.location")}
              </Typography>
              {/* <Typography fontSize={{ xs: "14px", sm: "16px" }}>
                {t("mapbox.locationText")}{" "}
              </Typography> */}
              <button
                className="btn"
                onClick={() => setShowLocation(!showLocation)}
              >
                {showLocation ? <AiOutlinePlus /> : <AiOutlineMinus />}
              </button>
            </header>
            {!showLocation && (
              <>
                <Box sx={{ mt: 2 }}>
                  <MapboxAPI
                    center={location}
                    height={"300px"}
                    zoom={17}
                    handleLocation={handleChosenLocation}
                    componentDisplay={"newProject"}
                    elevation={project.elevation}
                    handleChange={handleProjectChange}
                  />
                </Box>
              </>
            )}
          </Paper>
          <Backdrop
            sx={{
              color: theme.palette.primary.light,
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={loading}
          >
            <CircularProgress />
          </Backdrop>
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
          >
            <Box>
              <header>
                <Typography component="h2" variant="h5">
                  {t("createproject.summer")}
                </Typography>
                <button
                  className="btn"
                  onClick={() => setShowSummerWinter(!showSummerWinter)}
                >
                  {showSummerWinter ? <AiOutlineMinus /> : <AiOutlinePlus />}
                </button>
              </header>

              <>
                <Box sx={{ display: "flex" }}>
                  <Box sx={{ width: "50%" }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={manualAdjustmentsChecked}
                          onChange={handleChangeSummerWinter}
                          sx={{ ml: 2, mt: 2 }}
                        />
                      }
                      label={t("createproject.manual")}
                    />
                  </Box>

                  {!manualAdjustmentsChecked && (
                    <>
                      <Box sx={{ width: "30%" }}>
                        <TextField
                          disabled
                          fullWidth
                          id="stationName"
                          label={t("createproject.stationName")}
                          name="stationName"
                          value={project.stationName}
                          type="text"
                          inputType="text"
                        />
                      </Box>
                      <Box sx={{ width: "10%", paddingLeft: "10px" }}>
                        <TextField
                          disabled
                          fullWidth
                          id="stationId"
                          label={t("createproject.stationId")}
                          name="stationId"
                          value={project.stationId}
                          type="text"
                          inputType="text"
                        />
                      </Box>
                      <Box sx={{ width: "15%", paddingLeft: "10px" }}>
                        <TextField
                          disabled
                          fullWidth
                          id="distanceTemperature"
                          label={t("createproject.distance")}
                          name="distanceTemperature"
                          value={project.distanceTemperature}
                          type="number"
                          inputType="number"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">km</InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                    </>
                  )}
                </Box>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <TextField
                    margin="normal"
                    disabled={manualAdjustmentsChecked ? false : true}
                    fullWidth
                    id="summerOutdoorTemperature"
                    label={t("createproject.dryBulbTemperatureCelsius")}
                    name="summerOutdoorTemperature"
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.summerOutdoorTemperature
                        : project.summerOutdoorTemperature
                    }
                    onChange={(e) => {
                      setSummerOutdoorTemperature(false);
                      handleProjectChange(e);
                    }}
                    onFocus={handleFocus}
                    inputType="number"
                    type="number"
                    inputProps={{
                      step: 0.1,
                      min: -89,
                      max: 57,
                    }}
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      summerOutdoorTemperature
                        ? `${t(
                            "createproject.validationSummerOutdoorTemperature"
                          )}`
                        : ""
                    }
                    error={summerOutdoorTemperature}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">°C</InputAdornment>
                      ),
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                  <TextField
                    margin="normal"
                    disabled
                    fullWidth
                    id="summerWetBulbTemperature"
                    label={t("createproject.wetBulbTemperatureCelsius")}
                    name="summerWetBulbTemperature"
                    autoComplete={t("createproject.wetBulbTemperatureCelsius")}
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.summerWetBulbTemperature
                        : project.summerWetBulbTemperature
                    }
                    //onChange={handleProjectChange}
                    inputType="number"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      step: 0.1,
                    }}
                    helperText={
                      summerWetBulbTemperature
                        ? `${t(
                            "createproject.validationSummerWetBulbTemperature"
                          )}`
                        : ""
                    }
                    error={summerWetBulbTemperature}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">°C</InputAdornment>
                      ),
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                  <TextField
                    margin="normal"
                    disabled
                    fullWidth
                    focused
                    id="summerDewPointTemperature"
                    label={t("createproject.dewPointTemperatureCelsius")}
                    name="summerDewPointTemperature"
                    autoComplete={t("createproject.dewPointTemperatureCelsius")}
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.summerDewPointTemperature
                        : project.summerDewPointTemperature
                    }
                    inputType="number"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      summerDewPointTemperature
                        ? `${t(
                            "createproject.validationSummerDewPointTemperature"
                          )}`
                        : ""
                    }
                    error={summerDewPointTemperature}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">°C</InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    margin="normal"
                    disabled={manualAdjustmentsChecked ? false : true}
                    fullWidth
                    id="summerOutdoorHumidity"
                    label={t("createproject.relativeHumiditySummer")}
                    name="summerOutdoorHumidity"
                    onChange={(e) => {
                      setSummerOutdoorHumidity(false);
                      handleProjectChange(e);
                    }}
                    onFocus={handleFocus}
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.summerOutdoorHumidity
                        : project.summerOutdoorHumidity
                    }
                    type="number"
                    inputType="number"
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      summerOutdoorHumidity
                        ? `${t(
                            "createproject.validationSummerOutdoorHumidity"
                          )}`
                        : ""
                    }
                    error={summerOutdoorHumidity}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">%</InputAdornment>
                      ),
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                  <Typography component="h2" variant="h5">
                    {t("createproject.winter")}
                  </Typography>
                  <TextField
                    margin="normal"
                    disabled={manualAdjustmentsChecked ? false : true}
                    fullWidth
                    id="winterOutdoorTemperature"
                    label={t("createproject.heatingDB")}
                    name="winterOutdoorTemperature"
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.winterOutdoorTemperature
                        : project.winterOutdoorTemperature
                    }
                    onChange={(e) => {
                      setWinterOutdoorTemperature(false);
                      handleProjectChange(e);
                    }}
                    onFocus={handleFocus}
                    type="number"
                    inputProps={{
                      step: 0.1,
                    }}
                    inputType="number"
                    helperText={
                      winterOutdoorTemperature
                        ? `${t(
                            "createproject.validationWinterOutdoorTemperature"
                          )}`
                        : ""
                    }
                    InputLabelProps={{ shrink: true }}
                    error={winterOutdoorTemperature}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">°C</InputAdornment>
                      ),

                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                  <TextField
                    margin="normal"
                    required
                    disabled
                    fullWidth
                    id="winterOutdoorHumidityRatio"
                    label={t("createproject.humidityRatio")}
                    name="winterOutdoorHumidityRatio"
                    autoComplete={t("createproject.humidityRatio")}
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.winterOutdoorHumidityRatio
                        : project.winterOutdoorHumidityRatio
                    }
                    onChange={handleProjectChange}
                    type="number"
                    inputType="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      step: 0.1,
                    }}
                    helperText={
                      winterOutdoorTemperature
                        ? `${t("createproject.validationHumidityRatio")}`
                        : ""
                    }
                    //error={ heatingDB1 }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">g/g</InputAdornment>
                      ),
                      onWheel: (e) => e.target.blur(),
                    }}
                  />

                  <TextField
                    margin="normal"
                    disabled={manualAdjustmentsChecked ? false : true}
                    fullWidth
                    id="winterOutdoorHumidity"
                    label={t("createproject.relativeHumidityWinter")}
                    name="winterOutdoorHumidity"
                    onChange={(e) => {
                      setWinterOutdoorHumidity(false);
                      handleProjectChange(e);
                    }}
                    onFocus={handleFocus}
                    value={
                      !manualAdjustmentsChecked
                        ? initialValues.winterOutdoorHumidity
                        : project.winterOutdoorHumidity
                    }
                    type="number"
                    inputType="number"
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      winterOutdoorHumidity
                        ? `${t(
                            "createproject.validationWinterOutdoorHumidity"
                          )}`
                        : ""
                    }
                    error={winterOutdoorHumidity}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">%</InputAdornment>
                      ),
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                </Box>
              </>
            </Box>
            {showSummerWinter && (
              <>
                <Box sx={{ mt: 2 }}>
                  <TableDryWetMean
                    dryBulbTemperatures={dryBulbTemperatures}
                    wetBulbTemperatures={wetBulbTemperatures}
                    meanDailyTemperatureRange={meanDailyTemperatureRange}
                  />
                </Box>
              </>
            )}
          </Paper>
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
          >
            <Typography component="h2" variant="h5">
              {t("createproject.utilityrates")}
            </Typography>
            <Box sx={{ m: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={electricity}
                    onChange={handleChangeElectricity}
                  />
                }
                label={t("createproject.manual")}
              />
            </Box>

            <Box sx={{ display: "flex" }}>
              <TextField
                margin="normal"
                required
                disabled={!electricity}
                fullWidth
                id="elPriceBusiness"
                label={t("createproject.electricity")}
                name="elPriceBusiness"
                value={
                  !electricity
                    ? initialValues.elPriceBusiness
                    : project.elPriceBusiness
                }
                onChange={(e) => {
                  setElectricityUtilityRates(false);
                  handleProjectChange(e);
                }}
                type="number"
                inputType="number"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  step: 0.001,
                }}
                helperText={
                  elPriceBusiness
                    ? `${t("createproject.validationRequired")}`
                    : ""
                }
                error={elPriceBusiness}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">€/kWh</InputAdornment>
                  ),
                  onWheel: (e) => e.target.blur(),
                }}
                sx={{ width: "50%", m: 1 }}
              />
              <TextField
                margin="normal"
                required
                disabled={!electricity}
                fullWidth
                id="elPriceHome"
                label={t("createproject.electricityhome")}
                name="elPriceHome"
                value={
                  !electricity ? initialValues.elPriceHome : project.elPriceHome
                }
                onChange={(e) => {
                  setElPriceHome(false);
                  handleProjectChange(e);
                }}
                type="number"
                inputType="number"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  step: 0.001,
                }}
                helperText={
                  elPriceHome ? `${t("createproject.validationRequired")}` : ""
                }
                error={elPriceHome}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">€/kWh</InputAdornment>
                  ),
                  onWheel: (e) => e.target.blur(),
                }}
                sx={{ width: "50%", m: 1 }}
              />
            </Box>
          </Paper>
          <Paper
            variant="outlined"
            sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
          >
            <Box>
              <header>
                <Typography component="h4" variant="h6">
                  {t("createproject.airquality")}
                </Typography>
                <button
                  className="btn"
                  onClick={() => setShowAirQuality(!showAirQuality)}
                >
                  {showAirQuality ? <AiOutlineMinus /> : <AiOutlinePlus />}
                </button>
              </header>
              <Box>
                <Box sx={{ display: "flex" }}>
                  <Box sx={{ width: "50%", p: 2, mt: 2 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={airQuality}
                          onChange={handleChangeAirQuality}
                        />
                      }
                      label={t("createproject.manual")}
                    />
                  </Box>
                  {!airQuality && (
                    <Box sx={{ display: "flex", width: "50%" }}>
                      <TextField
                        disabled
                        fullWidth
                        id="distance"
                        label={t("createproject.distance")}
                        name="distance"
                        value={project.distance}
                        type="number"
                        inputType="number"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">km</InputAdornment>
                          ),
                        }}
                        sx={{ px: 1 }}
                      />
                    </Box>
                  )}
                </Box>

                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    disabled={!airQuality}
                    fullWidth
                    id="aqiCurrent"
                    label={t("createproject.aqi")}
                    name="aqiCurrent"
                    autoComplete={t("createproject.aqi")}
                    value={
                      !airQuality
                        ? initialValues.aqiCurrent
                        : project.aqiCurrent
                    }
                    onChange={(e) => {
                      setAqiCurrent(false);
                      handleProjectChange(e);
                    }}
                    inputType="number"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      onWheel: (e) => e.target.blur(),
                    }}
                    helperText={
                      aqiCurrent
                        ? `${t("createproject.validationRequired")}`
                        : ""
                    }
                    error={aqiCurrent}
                    sx={{ width: "50%", m: 1 }}
                  />
                  <TextField
                    margin="normal"
                    disabled={!airQuality}
                    fullWidth
                    id="aqiYearlyAverage"
                    label={t("createproject.aqiAvg")}
                    name="aqiYearlyAverage"
                    autoComplete={t("createproject.aqiAvg")}
                    value={
                      !airQuality
                        ? initialValues.aqiYearlyAverage
                        : project.aqiYearlyAverage
                    }
                    onChange={(e) => {
                      setAqiYearlyAverage(false);
                      handleProjectChange(e);
                    }}
                    inputType="number"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      onWheel: (e) => e.target.blur(),
                    }}
                    helperText={
                      aqiYearlyAverage
                        ? `${t("createproject.validationRequired")}`
                        : ""
                    }
                    error={aqiYearlyAverage}
                    sx={{ width: "50%", m: 1 }}
                  />
                </Box>
              </Box>
            </Box>
            {showAirQuality && (
              <>
                <Box sx={{ width: "60%", height: "40%", mx: "auto" }}>
                  <ChartAQI
                    aqiQualityGood={project.qualityGood}
                    aqiQualityModerate={project.qualityModerate}
                    aqiQualitySensitive={project.qualitySensitive}
                    aqiQualityUnhealthy={project.qualityUnhealthy}
                    aqiQualityUnhealthyV={project.qualityUnhealthyV}
                    aqiQualityHazardous={project.qualityHazardous}
                  ></ChartAQI>
                </Box>
                <Box sx={{ width: "100%", height: "50%", mx: "auto" }}>
                  <TableAirQualityLevels></TableAirQualityLevels>
                </Box>
              </>
            )}
          </Paper>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              fontSize: "20px",
              background: theme.palette.secondary.main,
              mt: 3,
              mb: 2,
              "&:hover": {
                color: theme.palette.secondary.main,
                backgroundColor: theme.palette.primary.dark,
              },
            }}
            onClick={createProject}
          >
            {t("createproject.savebtn")}
          </Button>
          <Typography variant="body2">
            {t("createproject.requiredField")}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default CreateProject;
